import { useKaiProApiClient } from '../../../useKaiProApiClient';

import { ScanDataSyncRecord, useScanDataSyncModel } from '../Models';
import { Syncer, SyncerProps, syncItemBatch } from './syncItemBatch';
import { SYNC_TIMEOUT_SECONDS } from './syncLib';

export const useScanDataSyncer = ({ syncLogger, addError, addSuccess, isPausedRef }: SyncerProps): Syncer<ScanDataSyncRecord> => {
  const kaiProApiClient = useKaiProApiClient();
  const model = useScanDataSyncModel();

  return {
    model,
    syncLogger,
    addError,
    isPausedRef,
    sync: pendingItems =>
      syncItemBatch({
        pendingItems,
        model,
        addError,
        addSuccess,
        syncLogger,
        isPausedRef,
        syncOne: (scanId, item) => kaiProApiClient.saveScanDataDelta(scanId, [item.scanData], SYNC_TIMEOUT_SECONDS),
        batchSync: (scanId, items) => kaiProApiClient.saveScanDataDelta(scanId, items.map(item => item.scanData), SYNC_TIMEOUT_SECONDS),
        batchSize: 100,
        singleSyncConcurrencyLimit: 5,
      }),
  };
};
